import React from "react";
import { Navigate, useParams, useLocation } from "react-router-dom";
import { useUser } from "../contexts/UserContext";
import LoadingOverlay from "../components/LoadingOverlay";

interface Props {
  children: JSX.Element;
}

const RequireProfileAccess: React.FC<Props> = ({ children }) => {
  const { authUser, isFetchingUser } = useUser();
  const { id } = useParams<{ id?: string }>();
  const location = useLocation();

  if (isFetchingUser) {
    return <LoadingOverlay />;
  }

  if (!authUser) {
    return <Navigate to="/404" state={{ from: location }} replace />;
  }

  // 管理者判定：isSystemAdmin OR isPublicAdmin が true なら管理者
  const isAdmin = authUser.isSystemAdmin || authUser.isPublicAdmin;

  // id がない場合は管理者だけ許可
  if (!id) {
    if (!isAdmin) {
      return <Navigate to="/404" state={{ from: location }} replace />;
    }
    return children;
  }

  const isOwner = authUser.id.toString() === id;

  // 管理者または自分のページのみアクセス可能
  if (!isAdmin && !isOwner) {
    return <Navigate to="/404" state={{ from: location }} replace />;
  }

  return children;
};

export default RequireProfileAccess;
